// Shared contrast treatment for zone previews, editors and fleet maps.
export const ZONE_STYLE = Object.freeze({color:'#D92D20',fill:'rgba(217,45,32,0.25)',opacity:.25,outline:'#FFFFFF',outlineWidth:7,strokeWidth:3});
